module.exports = __webpack_public_path__ + "static/media/investure-white.dadb48a1.png";